import HeroSection from "./HeroSection";
import AffordablePrice from "./Partials/AffordablePrice";
import FAQs from "./Partials/FAQs";
import FeaturesSection from "./Partials/FeaturesSection";
import Footer from "./Partials/Footer";
import Header from "./Partials/Header";
import WhyBeSeen from "./Partials/WhyBeSeen";

const HomePage = () => {
    return (
        <div className="no-scrollbar overflow-auto">
            <Header/>
            <HeroSection/>
            <WhyBeSeen/>
            <FeaturesSection/>
            <AffordablePrice/>
            <FAQs/>
            <Footer/>
        </div>
    )
};
export default HomePage;
